import { useContext } from 'react'
import CategoryDetailsContext from '../CategoryDetailsContext'

const useCategoryDetailsContext = (component, force = true) => {
  const context = useContext(CategoryDetailsContext)
  if (force && !context) {
    const err = new Error(`<${component} /> is missing CategoryDetailsContext`)
    if (Error.captureStackTrace)
      Error.captureStackTrace(err, useCategoryDetailsContext)
    throw err
  }
  return context
}

export default useCategoryDetailsContext
